export default __webpack_public_path__ + "static/media/UniFic.b43b530b.png";